import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { EStageId } from '../../utils/journeysUtils';

// GraphQL mutation
const UPDATE_JOURNEY_STAGE_MUTATION = gql`
  mutation updateJourneyStage($id: String!, $currentStage: EStageId!) {
    updateJourney(id: $id, data: { currentStage: $currentStage }) {
      _id
      currentStage
      completedAt
      gameType
      userId
      history {
        stageId
        type
        completedAt
        details
      }
    }
  }
`;

// Input types for TypeScript
export interface UpdateJourneyStageMutationType {
  updateJourney: {
    _id: string;
    currentStage: EStageId;
    completedAt?: string;
    gameType: string;
    userId: string;
    history: {
      stageId: EStageId;
      type: string;
      completedAt: string;
      details?: string;
    }[];
  };
}

export interface UpdateJourneyStageMutationVariables {
  id: string;
  currentStage: EStageId;
}

// Custom hook
export function useUpdateJourneyStageMutation(
  options?: MutationHookOptions<
    UpdateJourneyStageMutationType,
    UpdateJourneyStageMutationVariables
  >,
) {
  return useMutation<UpdateJourneyStageMutationType, UpdateJourneyStageMutationVariables>(
    UPDATE_JOURNEY_STAGE_MUTATION,
    options,
  );
}
